import { Cover, LayoutCoverImage, PersonalCard, Profile } from "./styles";
import BackgroundImg from "../../assets/fotoPerfil.jpeg";
import LayoutImage from "../../assets/capa.jpg";

export const Perfil: React.FC = () => {
  return (
    <PersonalCard id="home" className="pb-5">
      <LayoutCoverImage src={LayoutImage} alt="Foto de capa" />
      <Profile>
        <Cover style={{ backgroundImage: `url(${BackgroundImg})` }} />

        <strong className="mt-4">Paula Nader</strong>
        <span>Front-end developer</span>
      </Profile>
    </PersonalCard>
  );
};
